<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions">
         

          <!-- Export -->
          <div class="me-2 mb-2">
            <button
              class="btn btn-white d-inline-flex align-items-center"
              @click="exportCsv"
              v-can="'Deal.Export'"
            >
              <i class="ti ti-file-type-csv me-1"></i>Export CSV
            </button>
          </div>

          <!-- Add Deal -->
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              @click="openAdd"
              v-can="'Deal.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Deal
            </a>
          </div>

          <!-- Collapse header -->
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Deal List Card -->
      <div class="card">
        <!-- Filters Row -->
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Deal List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 dq-list-toolbar"
          >
            <!-- Date Range -->
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                  @change="applyDateRange"
                />
                <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
              </div>
            </div>

            <!-- Stage Filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Stage: {{ stageLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setStage(null)">
                    All Stages
                  </a>
                </li>
                <li v-for="s in stagesList" :key="s.id">
                  <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setStage(s.id)">
                    {{ s.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Status Filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Status: {{ statusLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setStatus('')">All</a></li>
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setStatus('Open')">Open</a></li>
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setStatus('Won')">Won</a></li>
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setStatus('Lost')">Lost</a></li>
              </ul>
            </div>

            <!-- Sort (simple presets) -->
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort: {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setSort('recent')">Recently Added</a></li>
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setSort('amount_desc')">Amount (High → Low)</a></li>
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setSort('amount_asc')">Amount (Low → High)</a></li>
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setSort('prob_desc')">Probability (High → Low)</a></li>
                <li><a class="dropdown-item rounded-1" href="javascript:void(0);" @click="setSort('prob_asc')">Probability (Low → High)</a></li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="card-body p-0">
          <div v-can="'Deal.Read'" class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="tableData"
              :loading="dealStore.loading"
              :pagination="false"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <!-- Deal Name (click to edit) -->
                <template v-if="column.key === 'DealName'">
                  <h6 class="fw-medium fs-14">
                     <router-link
                        :to="{
                          name: 'crm.deals.details',
                          params: { id: record.id },
                        }"
                      >
                        {{ record.name }}
                      </router-link>

                  </h6>
                </template>

                <!-- Stage -->
                <template v-else-if="column.key === 'Stage'">
                  <span>{{ record.stage?.name || '-' }}</span>
                </template>

                <!-- Deal Value -->
                <template v-else-if="column.key === 'DealValue'">
                  <span>{{ record.currency || 'KES' }} {{ Number(record.amount || 0).toLocaleString() }}</span>
                </template>

                <!-- Tags -->
                <template v-else-if="column.key === 'Tags'">
                  <span
                    v-for="t in (record.tags || [])"
                    :key="t"
                    class="badge bg-light text-dark me-1"
                  >{{ t }}</span>
                </template>

                <!-- Expected Close Date -->
                <template v-else-if="column.key === 'ExpectedClosedDate'">
                  <span>{{ record.expected_close_date || '-' }}</span>
                </template>

                <!-- Owner -->
                <template v-else-if="column.key === 'Owner'">
                  <span>
                    {{
                      record.owner?.first_name
                        ? (record.owner.first_name + ' ' + (record.owner.last_name || ''))
                        : (record.owner?.email || '-')
                    }}
                  </span>
                </template>

                <!-- Probability -->
                <template v-else-if="column.key === 'Probability'">
                  <span>{{ record.probability != null ? record.probability + '%' : '-' }}</span>
                </template>

                <!-- Status -->
                <template v-else-if="column.key === 'Status'">
                  <span
                    :class="[
                      'badge',
                      record.status === 'Open' ? 'badge-info' :
                      record.status === 'Won'  ? 'badge-success' :
                      record.status === 'Lost' ? 'badge-danger' : 'badge-secondary',
                      'badge-xs','align-items-center','d-inline-flex'
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ record.status }}
                  </span>
                </template>

                <!-- Actions -->
                <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                      <router-link
                        :to="{
                          name: 'crm.deals.details',
                          params: { id: record.id },
                        }"
                        class="me-2"
                        v-can="'Deal.Read'"
                      >
                        <i class="ti ti-eye"></i>
                      </router-link>
                    <a href="javascript:void(0);" class="me-2" @click="openEdit(record)" v-can="'Deal.Edit'">
                      <i class="ti ti-edit"></i>
                    </a>
                    <a href="javascript:void(0);" @click="openDelete(record)" v-can="'Deal.Delete'"
                        ><i class="ti ti-trash"></i
                      ></a>
                  </div>
                </template>

                <!-- Fallback -->
                <template v-else>
                  <span>{{ record[column.dataIndex] }}</span>
                </template>
              </template>
            </a-table>
          </div>

          <!-- Pagination -->
          <div class="p-3 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-3">
              <small>Total: {{ dealStore.pagination.total }}</small>
              <div class="d-flex align-items-center">
                <label class="me-2">Per page</label>
                <select
                  class="form-select form-select-sm"
                  style="width: auto"
                  v-model.number="dealStore.filters.per_page"
                  @change="reloadSafePerPage"
                >
                  <option :value="10">10</option>
                  <option :value="25">25</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                  <option :value="200">200</option>
                </select>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <button
                class="btn btn-sm btn-light me-2"
                :disabled="dealStore.pagination.current_page <= 1"
                @click="reload({ page: dealStore.pagination.current_page - 1 })"
              >
                Prev
              </button>
              <button
                class="btn btn-sm btn-light"
                :disabled="dealStore.pagination.current_page * dealStore.pagination.per_page >= dealStore.pagination.total"
                @click="reload({ page: dealStore.pagination.current_page + 1 })"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /Deal List Card -->
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a></p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- Shared Add/Edit Modal -->
  <deals-modal :editItem="editItem" @saved="reload()" />
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted, computed, nextTick } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";

import { useDealStore } from "@/stores/dealStore";
import { usePipelineStore } from "@/stores/pipelineStore";
import { useUserStore } from "@/stores/userStore";

import DealsModal from "@/components/modal/deals-modal.vue";
import Modal from "bootstrap/js/dist/modal";

/* Page meta */
const title = "Deals";
const text = "CRM";
const text1 = "Deal List";

/* Stores */
const dealStore = useDealStore();
const pipeStore = usePipelineStore();
const userStore = useUserStore();

/* Local state */
const dateRangeInput = ref(null);
const editItem = ref(null);

/* Columns (Ant Design Vue style) */
const columns = [
  { sorter: false },
  { title: "Deal Name", key: "DealName", dataIndex: "name" },
  { title: "Stage", key: "Stage", dataIndex: "stage" },
  { title: "DealValue", key: "DealValue", dataIndex: "amount" },
  { title: "Tags", key: "Tags", dataIndex: "tags" },
  { title: "Expected Closed Date", key: "ExpectedClosedDate", dataIndex: "expected_close_date" },
  { title: "Owner", key: "Owner", dataIndex: "owner" },
  { title: "Probability", key: "Probability", dataIndex: "probability" },
  { title: "Status", key: "Status", dataIndex: "status" },
  { title: "", key: "action", sorter: false },
];

/* Derived table data (already good from API) */
const tableData = computed(() => dealStore.items || []);

/* Stage list (from pipelines) */
const stagesList = computed(() => {
  const ps = pipeStore.items || [];
  const all = [];
  ps.forEach(p => (p.stages || []).forEach(s => all.push({ id: s.id, name: s.name })));
  // unique by id
  const seen = new Set();
  return all.filter(s => (seen.has(s.id) ? false : seen.add(s.id)));
});

const stageLabel = computed(() => {
  const id = dealStore.filters.stage_id;
  if (!id) return "All";
  const s = stagesList.value.find(x => Number(x.id) === Number(id));
  return s ? s.name : `Stage #${id}`;
});

const statusLabel = computed(() => dealStore.filters.status || "All");
const sortLabel = computed(() => {
  switch (dealSort.value) {
    case "amount_desc": return "Amount (High → Low)";
    case "amount_asc":  return "Amount (Low → High)";
    case "prob_desc":   return "Probability (High → Low)";
    case "prob_asc":    return "Probability (Low → High)";
    default:            return "Recently Added";
  }
});

/* Very light client-side sort descriptor used to request server */
const dealSort = ref("recent"); // recent | amount_desc | amount_asc | prob_desc | prob_asc

/* Actions */
function openAdd() {
  editItem.value = null; 
  nextTick(() => {
    const el = document.getElementById("add_deals");
    Modal.getOrCreateInstance(el)?.show();
  });
}


function openEdit(row) {
  editItem.value = row;
  nextTick(() => {
    const el = document.getElementById("add_deals");
    Modal.getOrCreateInstance(el)?.show();
  });
}


function openDelete(row) {
  editItem.value = row;
  nextTick(() => {
    const el = document.getElementById("delete_deals");
    Modal.getOrCreateInstance(el)?.show();
  });
}


function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

/* Filters mutations */
function setStage(id) {
  dealStore.filters.stage_id = id || null;
  dealStore.filters.page = 1;
  reload();
}
function setStatus(v) {
  dealStore.filters.status = v || "";
  dealStore.filters.page = 1;
  reload();
}
function setSort(v) {
  dealSort.value = v;
  // Map the simple sort to API extra params as needed.
  // (If your backend supports sort params, add them here.)
  // For now we just reload; server already sorts by recent (id desc).
  reload();
}

/* Date range handling */
function applyDateRange() {
  const val = dateRangeInput.value?.value || "";
  // daterangepicker returns like "M/D/YYYY - M/D/YYYY"
  const parts = val.split("-").map(s => s.trim());
  if (parts.length === 2) {
    const from = moment(parts[0], ["DD/MM/YYYY","M/D/YYYY"]).format("YYYY-MM-DD");
    const to   = moment(parts[1], ["DD/MM/YYYY","M/D/YYYY"]).format("YYYY-MM-DD");
    if (from !== "Invalid date") dealStore.filters.date_from = from;
    if (to   !== "Invalid date") dealStore.filters.date_to   = to;
    dealStore.filters.page = 1;
    reload();
  }
}

function reload(extra = {}) {
  // clamp per_page to <= 200 to satisfy backend rule
  if (!extra.per_page && dealStore.filters.per_page > 200) {
    dealStore.filters.per_page = 200;
  }
  dealStore.fetchAll(extra);
}
function reloadSafePerPage() {
  if (dealStore.filters.per_page > 200) dealStore.filters.per_page = 200;
  dealStore.filters.page = 1;
  reload();
}

/* Exports (stub hooks – wire to your real exporters) */
function exportCsv() {
  const header = [
    "Name",
    "Account",
    "Stage",
    "Status",
    "Owner",
    "Amount",
    "Probability",
    "Expected Close",
    "Created At",
  ];
  const body = (Array.isArray(tableData.value) ? tableData.value : []).map((deal) => [
    deal.name || "",
    deal.company_name || deal.client?.name || "",
    deal.stage?.name || "",
    deal.status || "",
    [deal.owner?.first_name, deal.owner?.last_name].filter(Boolean).join(" ") ||
      deal.owner?.email ||
      "",
    `${deal.currency || "KES"} ${Number(deal.amount || 0).toFixed(2)}`,
    deal.probability != null ? `${deal.probability}%` : "",
    deal.expected_close_date || "",
    deal.created_at || "",
  ]);

  const csv = [header, ...body]
    .map((row) =>
      row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `crm-deals-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/* Init */
onMounted(async () => {
  if (!pipeStore.items?.length) await pipeStore.ensureAll({ per_page: 200 });
  if (!userStore.users?.length) await userStore.fetchUsers({ per_page: 200 });
  await dealStore.ensureList();

  if (dateRangeInput.value) {
    const start = moment().subtract(6, "days");
    const end = moment();
    new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      () => applyDateRange()
    );
  }
});
</script>

<style scoped>
/* keep table area tidy */
.custom-datatable-filter { padding: 0 1rem; }

@media (max-width: 767.98px) {
  .dq-list-toolbar {
    align-items: stretch !important;
  }

  .dq-list-toolbar > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-list-toolbar .dropdown,
  .dq-list-toolbar .dropdown-toggle,
  .dq-list-toolbar .form-control,
  .dq-list-toolbar .input-icon-end {
    width: 100%;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style


